module.exports = __webpack_public_path__ + "img/A19_20120114-001.048df3be.jpg";